// extracted by mini-css-extract-plugin
module.exports = {"icon-warning":"icon-warning___3h0OB","title":"title___2hAcm"};